module.exports = __webpack_public_path__ + "static/img/__1304.a7c0410.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__1304.jpg
// module id = b3xj
// module chunks = 0